import { render, staticRenderFns } from "./tabs-router.vue?vue&type=template&id=77a03135&"
import script from "./tabs-router.vue?vue&type=script&lang=js&"
export * from "./tabs-router.vue?vue&type=script&lang=js&"
import style0 from "./tabs-router.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tabs-router.vue"
export default component.exports